import React from "react";
import { connect } from "react-redux";
import "../css/careersPage.css";

const CareersPage = ({ careerData }) => {
    if (!careerData) return null; 

    return (
        <div className="careers-container">
            <header className="careers-header">
                <h1>{careerData.title}</h1>
                <p>{careerData.description}</p>
            </header>
            <div className="image-container">
                <img src={careerData.image_url} alt="Careers" className="zoom-image" />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
  careerData: state.career.data, 
});

export default connect(mapStateToProps)(CareersPage);
